export const BRANDS_WITH_MONARX = ['bluehost', 'hostgator'];
export enum MonarxPlan {
  Level0 = 'level0',
  Level1 = 'level1',
  Level2 = 'level2',
  Level3 = 'level3',
}
export const MONARX_PLANS_WITH_MALWARE_UPGRADE = ['level0', 'level1', 'level2'];
export const THREATSHIELD_PLAN = 'level3';
export const HEALTH_STATUS_INFECTED = 'detected';
export const HEALTH_STATUS_CLEAN = 'not_detected';
export const HEALTH_STATUS_UNKNOWN = 'unknown';

export enum HealthStatus {
  Infected = HEALTH_STATUS_INFECTED,
  Clean = HEALTH_STATUS_CLEAN,
  Unknown = HEALTH_STATUS_UNKNOWN,
}
